module.exports = __webpack_public_path__ + "media/images/bg_faq_mv_sp-628b4f573868a27529e059cc319acd09.jpg";